import { snakeCase } from 'lodash';

const isArray = (a) => Array.isArray(a);

const isObject = (o) =>
  o === Object(o) && !isArray(o) && typeof o !== 'function';

const camelToSnake = (o) => {
  if (isObject(o)) {
    const n = {};

    Object.keys(o).forEach((k) => {
      n[snakeCase(k)] = camelToSnake(o[k]);
    });

    return n;
  }
  if (isArray(o)) {
    return o.map((i) => camelToSnake(i));
  }
  return o;
};

export default camelToSnake;
